import React from 'react'
import { ModelWithForm, ValueToCollection } from '@morningtrain/react-resources'
import { RouteParameterFilter } from '@morningtrain/react-filters'
import * as UI from 'ui'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import FieldActivity from 'support/displays/FieldActivity'
import FieldStatus from 'support/displays/FieldStatus'
import FieldLabel from 'support/displays/FieldLabel'
import { Translation } from '@morningtrain/react-translations'
import { Link } from '@morningtrain/react-navigation'
import * as Icons from 'ui/icons'
import { Table } from 'widgets/crud'

export default function ChecklistForm () {
  return (
    <ModelWithForm resourceName='checklists.checklists' autoFetch={false}>
      <RouteParameterFilter name='checklist' />

      <UI.Card>
        <UI.CardHeader>
          <UI.SecondaryHeading>
            <Displays.Text name='name' />
          </UI.SecondaryHeading>
          <Link route='app.checklists'>
            <UI.Button>
              <Icons.ArrowLeft className='mr-2' />
              <span><Translation name='checklists.actions.back_to_overview' /></span>
            </UI.Button>
          </Link>
        </UI.CardHeader>
        <ValueToCollection name='fields'>
          <Table>
            <Columns.Column label={<Translation name='task' />} display={<FieldLabel />} />
            <Columns.Column label={<Translation name='activity' />} display={<FieldActivity />} />
            <Columns.Column label={<Translation name='status' />} display={<FieldStatus />} />
          </Table>
        </ValueToCollection>
      </UI.Card>
    </ModelWithForm>
  )
}
